import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import { toast } from "sonner";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    // Replace these with your actual EmailJS credentials
    const serviceId = "YOUR_SERVICE_ID";
    const templateId = "YOUR_TEMPLATE_ID";
    const userId = "YOUR_USER_ID";

    emailjs
      .send(serviceId, templateId, data, userId)
      .then((response) => {
        toast.success("Message sent successfully!");
        reset(); // Reset form after successful submission
      })
      .catch((error) => {
        toast.error("Error sending message. Please try again.");
        console.error("EmailJS Error:", error);
      });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-card p-8 rounded-2xl shadow-lg max-w-md w-full mx-auto"
    >
      <h2 className="text-2xl font-bold text-white mb-6">Contact Me</h2>

      <div className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-gray-300 mb-2">
            Name
          </label>
          <input
            id="name"
            {...register("name", { required: "Name is required" })}
            className="w-full p-3 rounded-lg bg-background border border-border text-white"
            placeholder="Your name"
          />
          {errors.name && (
            <span className="text-red-500 text-sm mt-1">
              {errors.name.message}
            </span>
          )}
        </div>

        <div>
          <label htmlFor="email" className="block text-gray-300 mb-2">
            Email
          </label>
          <input
            id="email"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
            className="w-full p-3 rounded-lg bg-background border border-border text-white"
            placeholder="your.email@example.com"
          />
          {errors.email && (
            <span className="text-red-500 text-sm mt-1">
              {errors.email.message}
            </span>
          )}
        </div>

        <div>
          <label htmlFor="message" className="block text-gray-300 mb-2">
            Message
          </label>
          <textarea
            id="message"
            {...register("message", { required: "Message is required" })}
            rows="5"
            className="w-full p-3 rounded-lg bg-background border border-border text-white resize-none"
            placeholder="Your message here..."
          />
          {errors.message && (
            <span className="text-red-500 text-sm mt-1">
              {errors.message.message}
            </span>
          )}
        </div>

        <button
          type="submit"
          className="w-full bg-primary text-primary-foreground px-6 py-3 rounded-lg hover:opacity-90 transition-opacity"
        >
          Send Message
        </button>
      </div>
    </form>
  );
};

export default ContactForm;